import { ReactNode } from 'react';
import { Button, Icon, Text } from '@bitrise/bitkit';

import BuildListSkeletonOverlayContent from '../../../components/BuildListItem/BuildListSkeletonOverlayContent';

type BuildListLoadingErrorContentProps = { message: ReactNode; retry: VoidFunction };
const BuildListLoadingErrorContent = ({ message, retry }: BuildListLoadingErrorContentProps): JSX.Element => (
  <BuildListSkeletonOverlayContent textColor="red.40">
    <Icon name="ErrorGeneral" width="40px" height="40px" />
    <Text size="5" fontWeight="bold">
      {message}
    </Text>
    <Button variant="tertiary" onClick={() => retry && retry()}>
      Retry
    </Button>
  </BuildListSkeletonOverlayContent>
);

export { BuildListLoadingErrorContentProps };
export default BuildListLoadingErrorContent;
